import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { User } from './user';

@JsonObject('UserSearchResults')
export class UserSearchResults extends SearchResults {
    @JsonProperty('results', [User])
    results: User[] = [];
}
